<template>
    <div class="tw-flex tw-flex-col tw-mb-7">
        <div class="tw-flex tw-items-center tw-mb-3 md:tw-mb-3">
            <!--<calendar-icon :tEvent="{start_date: name}" format="YYYY-MM-DD"></calendar-icon>-->
            <div class="tw-flex tw-flex-col tw-ml-6 md:tw-ml-0">
                <h3 class="tw-mb-2 tw-font-semibold" v-text="readable_date"></h3>
            </div>
        </div>
        <event-list-item v-for="tEvent in events" :key="tEvent.id" :tEvent="tEvent"></event-list-item>
    </div>
</template>

<script>
    import moment from 'moment';
    import CalendarIcon from '@/resources/assets/js/vue/components/events/CalendarIcon';
    import EventListItem from '@/resources/assets/js/vue/components/events/EventListItem';

    export default {
        name: 'EventsDayList',

        components: {
            CalendarIcon,
            EventListItem,
        },

        props: {
            events: {
                required: true,
            },

            name: {
                required: true,
            },
            
        },

        computed: {
            readable_date() {
                return moment(this.name).format('dddd, DD MMMM');
            },
        },
    };
</script>